<template>
	<div>
		<loading :active.sync="isLoading" :can-cancel="true" :is-full-page="true" :opacity="0"></loading>
		<router-view></router-view>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	components: {
		Loading,
	},
	computed: {
		isLoading() {
			return this.$store.getters['isLoading'];
		},
	},
};
</script>
